export const globalHandlerUtils = {
  handleError: (error: any) => {
    console.log(error);
  },
};
